export const CFS_COLLECTION = "POLICE_CALLS_FOR_SERVICE";
export const CFS_INDEX = "index";

export function callsCatalog(index) {
  return Object.entries(index?.calls || {}).map(([id, value]) => ({ id, ...value }))
    .sort((left, right) => left.name.localeCompare(right.name));
}
export function callsDocumentIds(entry) {
  if (!entry) return [];
  return [entry.id, ...Array.from({ length: entry.parts || 0 }, (_, index) => `${entry.id}-p${String(index + 1).padStart(3, "0")}`)];
}
export function decodeCallsDocuments(documents) {
  return documents.sort((a, b) => a.part - b.part).flatMap(document => {
    const columns = [document.lat, document.lng, document.years, document.counts, document.streetIds];
    if (!columns.every(column => Array.isArray(column) && column.length === document.pointCount)) {
      throw new Error("Calls for Service map columns are incomplete");
    }
    if (document.receivedWallTimeMs && document.receivedWallTimeMs.length !== document.pointCount) {
      throw new Error("Calls for Service received-time column is incomplete");
    }
    return document.lat.map((latitude, index) => ({
      latitude: latitude / document.coordinateScale,
      longitude: document.lng[index] / document.coordinateScale,
      year: document.years[index],
      count: document.counts[index],
      receivedWallTimeMs: document.receivedWallTimeMs?.[index] ?? null,
      streetName: document.streetIds[index] < 0 ? null : document.streets[document.streetIds[index]],
      callType: document.callType || null,
    }));
  });
}
export function filterCallsPoints(points, fromYear, throughYear) {
  return points.filter(point => point.year >= fromYear && point.year <= throughYear);
}
export function groupCallsLocations(points) {
  const grouped = new Map();
  for (const point of points) {
    const key = `${point.latitude},${point.longitude}`;
    const existing = grouped.get(key);
    if (!existing) grouped.set(key, { ...point, latest: point });
    else {
      existing.count += point.count;
      if (!existing.streetName && point.streetName) existing.streetName = point.streetName;
      if (point.receivedWallTimeMs != null && (existing.latest.receivedWallTimeMs == null || point.receivedWallTimeMs > existing.latest.receivedWallTimeMs)) existing.latest = point;
    }
  }
  return [...grouped.values()];
}
